import { Controller } from '@hotwired/stimulus';
import { showToast } from '../utils/toast';

export default class extends Controller {
  static targets = ['field'];

  connect() {
    if (this.hasFieldTarget) this.#initToast();
  }

  teardown() {
    bootstrap.Toast.getInstance(this.fieldTarget)?.hide();
  }

  remove() {
    this.element.remove();
  }

  preview({ currentTarget }) {
    const { toastType, toastMessage, toastTitle } = currentTarget.dataset;
    showToast(toastType, toastMessage, toastTitle || null);
  }

  #initToast() {
    new bootstrap.Toast(this.fieldTarget, {
      animation: true,
      autohide: true,
      delay: 5000,
    }).show();
  }
}
